import { cn } from "@/lib/utils";

interface IconProps {
  className?: string;
}

/** Soft rounded map pin with inner dot — replaces MapPin */
export function IconPin({ className }: IconProps) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={cn("h-4 w-4", className)}
      aria-hidden="true"
    >
      {/* Pin body — rounder teardrop */}
      <path d="M12 2C8.13 2 5 5.13 5 9C5 13.25 12 22 12 22C12 22 19 13.25 19 9C19 5.13 15.87 2 12 2Z" />
      {/* Inner dot */}
      <circle cx="12" cy="9" r="2.5" fill="currentColor" opacity="0.25" />
    </svg>
  );
}
